var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.889 73.7223C147.889 114.437 114.882 147.445 74.1668 147.445C33.4558 147.445 0.44458 114.437 0.44458 73.7223C0.44458 33.0112 33.4558 0 74.1668 0C114.882 0 147.889 33.0112 147.889 73.7223Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5449 73.7225C53.1998 73.7225 57.7841 67.3046 57.7841 59.3876C57.7841 51.4707 53.1998 45.0527 47.5449 45.0527C41.8899 45.0527 37.3057 51.4707 37.3057 59.3876C37.3057 67.3046 41.8899 73.7225 47.5449 73.7225Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.789 73.7225C106.444 73.7225 111.028 67.3046 111.028 59.3876C111.028 51.4707 106.444 45.0527 100.789 45.0527C95.1338 45.0527 90.5496 51.4707 90.5496 59.3876C90.5496 67.3046 95.1338 73.7225 100.789 73.7225Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9336 114.151C36.6626 114.811 37.7521 114.852 38.5343 114.27C38.6941 114.151 54.5976 102.393 74.1668 102.393C93.6868 102.393 109.644 114.151 109.799 114.27C110.581 114.852 111.671 114.802 112.4 114.151C113.125 113.496 113.289 112.415 112.785 111.579C112.257 110.703 99.6091 90.1055 74.1668 90.1055C48.7244 90.1055 36.0728 110.699 35.5486 111.579C35.0448 112.419 35.2046 113.496 35.9336 114.151Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBad);
export default __webpack_public_path__ + "static/media/bad.8a287df390fd5b7cf0d3d049f9d51985.svg";
export { ForwardRef as ReactComponent };